import { Link } from "gatsby"
import { default as React, useState } from "react"

const Nav = () => {
  return <div className="Nav"></div>
}

export default Nav
